import * as configure from './configure';
import * as entry from './entry';
import * as proteinsApi from './proteinsApi';
import * as releaseNotes from './releaseNotes';
import * as results from './results';
import * as search from './search';
import * as suggester from './suggester';

export default {
  configure,
  entry,
  proteinsApi,
  releaseNotes,
  results,
  search,
  suggester,
};
